import { Checkbox, Input, InputGroup } from 'rsuite';
import styles from './RegraNotificacaoForm.module.scss';

export type RegraNotificacaoValue = {
  menorIgualAtivo: boolean;
  maiorIgualAtivo: boolean;
  entreAtivo: boolean;
  menorIgualValor: string;
  maiorIgualValor: string;
  entreValorMin: string;
  entreValorMax: string;
};

type RegraNotificacaoFormProps = {
  value: RegraNotificacaoValue;
  onChange: (value: RegraNotificacaoValue) => void;
  // 'grid' é o layout original (2 colunas + "entre" ocupando a linha inteira), usado na página cheia
  // de criação. 'stacked' é usado só pela CriarMonitoramentoModal, que pediu as 3 opções empilhadas.
  layout?: 'grid' | 'stacked';
};

export const RegraNotificacaoForm = ({ value, onChange, layout = 'grid' }: RegraNotificacaoFormProps) => {
  const isStacked = layout === 'stacked';

  const handleToggleMenorIgual = (_data: unknown, checked: boolean) => {
    onChange({ ...value, menorIgualAtivo: checked, entreAtivo: checked ? false : value.entreAtivo });
  };

  const handleToggleMaiorIgual = (_data: unknown, checked: boolean) => {
    onChange({ ...value, maiorIgualAtivo: checked, entreAtivo: checked ? false : value.entreAtivo });
  };

  const handleToggleEntre = (_data: unknown, checked: boolean) => {
    onChange({
      ...value,
      entreAtivo: checked,
      menorIgualAtivo: checked ? false : value.menorIgualAtivo,
      maiorIgualAtivo: checked ? false : value.maiorIgualAtivo,
    });
  };

  const handleChangeMenorIgualValor = (nextValue: string) => {
    onChange({ ...value, menorIgualValor: nextValue });
  };

  const handleChangeMaiorIgualValor = (nextValue: string) => {
    onChange({ ...value, maiorIgualValor: nextValue });
  };

  const handleChangeEntreValorMin = (nextValue: string) => {
    onChange({ ...value, entreValorMin: nextValue });
  };

  const handleChangeEntreValorMax = (nextValue: string) => {
    onChange({ ...value, entreValorMax: nextValue });
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h2 className={styles.title}>Regra da notificação</h2>
        <p className={styles.subtitle}>Escolha as regras que servirão de gatilho para o envio do seu alerta</p>
      </div>

      <div className={isStacked ? styles.rulesGridStacked : styles.rulesGrid}>
        <div className={styles.ruleCard}>
          <Checkbox checked={value.menorIgualAtivo} onChange={handleToggleMenorIgual} className={styles.checkbox}>
            <div className={styles.ruleContent}>
              <p className={styles.ruleTitle}>Competitividade menor ou igual a</p>
              <p className={styles.ruleSubtitle}>Informe o percentual que você deseja considerar no seu alerta.</p>
            </div>
          </Checkbox>
          <InputGroup className={styles.inputGroup}>
            <Input
              className={styles.input}
              value={value.menorIgualValor}
              onChange={handleChangeMenorIgualValor}
              disabled={!value.menorIgualAtivo}
            />
            <InputGroup.Addon className={styles.addon}>%</InputGroup.Addon>
          </InputGroup>
        </div>

        <div className={styles.ruleCard}>
          <Checkbox checked={value.maiorIgualAtivo} onChange={handleToggleMaiorIgual} className={styles.checkbox}>
            <div className={styles.ruleContent}>
              <p className={styles.ruleTitle}>Competitividade maior ou igual a</p>
              <p className={styles.ruleSubtitle}>Informe o percentual que você deseja considerar no seu alerta.</p>
            </div>
          </Checkbox>
          <InputGroup className={styles.inputGroup}>
            <Input
              className={styles.input}
              value={value.maiorIgualValor}
              onChange={handleChangeMaiorIgualValor}
              disabled={!value.maiorIgualAtivo}
            />
            <InputGroup.Addon className={styles.addon}>%</InputGroup.Addon>
          </InputGroup>
        </div>

        <div className={isStacked ? styles.ruleCard : `${styles.ruleCard} ${styles.ruleCardFull}`}>
          <Checkbox checked={value.entreAtivo} onChange={handleToggleEntre} className={styles.checkbox}>
            <div className={styles.ruleContent}>
              <p className={styles.ruleTitle}>Competitividade entre</p>
              <p className={styles.ruleSubtitle}>Informe os percentuais mínimo e máximo que definem a faixa do alerta.</p>
            </div>
          </Checkbox>
          <div className={styles.rangeInputs}>
            <InputGroup className={styles.inputGroup}>
              <Input
                className={styles.input}
                value={value.entreValorMin}
                onChange={handleChangeEntreValorMin}
                disabled={!value.entreAtivo}
                placeholder="Mín."
              />
              <InputGroup.Addon className={styles.addon}>%</InputGroup.Addon>
            </InputGroup>
            <span className={styles.rangeSeparator}>a</span>
            <InputGroup className={styles.inputGroup}>
              <Input
                className={styles.input}
                value={value.entreValorMax}
                onChange={handleChangeEntreValorMax}
                disabled={!value.entreAtivo}
                placeholder="Máx."
              />
              <InputGroup.Addon className={styles.addon}>%</InputGroup.Addon>
            </InputGroup>
          </div>
        </div>
      </div>
    </div>
  );
};
